
import { Mixins, Component } from 'vue-property-decorator';
import { IBTNCONF } from '@/types/base.d';
import BsMixin from '@/views/Home/mixins/bsMixin';
import tAction from '@/components/Action/action.vue';
import tableMixin from './tableMixin';
import deleteConfirmModal from '../Assignment/components/deleteConfirmModal.vue';
import addQuestionModal from './components/addQuestionModal.vue';
import { Button, Tooltip, Card, Loading } from 'element-ui';
import Draggable from 'vuedraggable';
import noData from '@/components/noData/index.vue';
import tIcon from '@/components/Icon/icon.vue';

@Component({
  components: {
    tAction,
    addQuestionModal,
    deleteConfirmModal,
    Button,
    Tooltip,
    Card,
    Draggable,
    noData,
    tIcon,
  },
  directives: {
    loading: Loading.directive,
  },
})
export default class Exercise extends Mixins(BsMixin, tableMixin) {
  private actionBtns: Array<IBTNCONF> = [{
    title: '新增题目',
    name: '/course/chapter/exercise:add',
    icon: 'plus',
    callback: this.handleAddQuestion,
    log: {
      name: '随堂练习 - 新增题目',
      component: 'course/chapter/exercise',
    },
  }];

  public visible = {
    addQuestion: false,
  };

  public row: any = {};

  public title: string = '';

  public $refs!: {
    list: Element,
  }

  // 拖拽配置选项
  private dragOptions = {
    animation: 150,
    forceFallback: false, // 使用原生 HTML5 拖拽
    fallbackOnBody: true, // 拖拽时附加到 body
    scroll: true, // 允许滚动
    scrollSensitivity: 100, // 滚动敏感度
    scrollSpeed: 20, // 滚动速度
    bubbleScroll: true, // 允许冒泡滚动
    preventOnFilter: false, // 不过滤事件
    filter: '.delete', // 排除删除按钮，避免点击删除时触发拖拽
  };

  mounted() {
    // 移除 Better Scroll 初始化，避免与拖拽功能冲突
    // this.initBS(this.$refs.list);
    if (this.chapterId) {
      this.getData(this.chapterId);
    }
  }

  handleAddQuestion() {
    this.row.chapterPid = this.chapterId;
    this.title = '添加题目';
    this.visible.addQuestion = true;
  }

  refrsh() {
    this.getData(this.chapterId);
  }
}
